import { useEffect } from "react";

/**
 * Sets document.title (and optionally the meta description) while the
 * component is mounted.
 */
export function useDocumentTitle(title?: string, description?: string) {
  useEffect(() => {
    if (!title) {
      return;
    }
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  useEffect(() => {
    if (!description) {
      return;
    }
    const meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      return;
    }
    const previousDescription = meta.content;
    meta.content = description;
    return () => {
      meta.content = previousDescription;
    };
  }, [description]);
}
